import { InfoButton } from '@drycut/ui-components';

export function CleanHairInfoButton(): React.ReactElement {
  return (
    <InfoButton
      title="Clean hair policy"
      text="Haare sollten keine oder wenig Produkte (Gel, Pomade, etc.) enthalten und in den vergangenen 24 Stunden gewaschen worden sein."
      className="z-20"
    />
  );
}
